module.exports = __webpack_public_path__ + "assets/img/solutions5.b2eea87b.png";